import axios from 'axios';
import Config from './Config';
import AccessToken from '../actions/AccessToken';

const BASE_URL = Config();
const getCommonResponse = {};
const token = AccessToken();
const headers =  {"x-api-key": process.env.REACT_APP_X_API_KEY}

getCommonResponse.GetLogin = (endpoint, data, callback) => {
    axios({
        method: 'POST',
        data: data,
        url: `${BASE_URL}${endpoint}`
    })
    .then(function(response) {
        callback(response);
    })
    .catch(function(error) {
        callback(error.response);
    })
}

getCommonResponse.GetLogout = (endpoint, accesstoken, callback) => {
    axios({
        method: 'POST',
        url: `${BASE_URL}${endpoint}`,
        headers: { Authorization: `Bearer ${accesstoken}` },
    })
    .then(function(response) {
        callback(response);
    })
    .catch(function(error) {
        callback(error.response);
    })
} 

getCommonResponse.GetRefreshResponse = (endpoint, data, callback) => {
    axios({
        method: 'POST',
        data: data,
        url: `${BASE_URL}${endpoint}`,
    })
    .then(function(response) {
        callback(response);
    })
    .catch(function(error) {
        callback(error.response);
    })
} 

getCommonResponse.GetDetailsWithApiKey = (endpoint, callback) => {
    axios({
        method: 'GET',
        url: endpoint,
        headers: headers
    })
    .then(function (response) {
        callback(response);
    })
    .catch(function (error) {
        callback(error.response);
    })
}

getCommonResponse.GetDetailsWithToken = (endpoint, accesstoken, callback) => {
    axios({
        method: 'GET',
        url: `${BASE_URL}${endpoint}`,
        headers: { Authorization: `Bearer ${accesstoken}` },
    })
    .then(function(response) {
        callback(response);
        console.log("res", response);
    })
    .catch(function(error) {
        callback(error.response);
    })
}

getCommonResponse.PostDetailsWithApiKey = (endpoint, data, callback) => {
    axios({
        method: 'POST',
        url: endpoint,
        data: data,
        headers: headers
    })
    .then(function (response) {
        callback(response);
    })
    .catch(function (error) {
        callback(error.response);
    })
}

getCommonResponse.PostDetails = (endpoint, accesstoken, data, callback) => {
    axios({
        method: 'POST',
        url: endpoint,
        data: data,
        headers: { Authorization: `Bearer ${accesstoken}` }
    })
    .then(function (response) {
        callback(response);
    })
    .catch(function (error) {
        callback(error.response);
    })
}

getCommonResponse.DeleteDetails = (endpoint, accesstoken, callback) => {
    axios({
        method: 'POST',
        url: endpoint,
        headers: { Authorization: `Bearer ${accesstoken}` }
    })
    .then(function (response) {
        callback(response);
    })
    .catch(function (error) {
        callback(error.response);
    })
}

getCommonResponse.DeleteApi = (endpoint, accesstoken, callback) => {
    axios({
        method: 'DELETE',
        url: endpoint,
        headers: { Authorization: `Bearer ${accesstoken}` }
    })
    .then(function (response) {
        callback(response);
    })
    .catch(function (error) {
        callback(error.response);
    })
}


export default getCommonResponse;
